import useSWR from "swr";

export const useExpenses = (searchQuery, productionId) => {
    let clientsKey;
    if (searchQuery) {
        const params = new URLSearchParams({ searchParams: searchQuery });
        if (productionId) {
            params.append('productionId', productionId.toString());
        }
        clientsKey = `/expense/search-expense?${params.toString()}`;
    } else if (productionId) {
        clientsKey = `/expense?productionId=${productionId}`;
    } else {
        clientsKey = `/expense`;
    }
    
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        expense: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};